








import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VDraggableList extends Vue {
  @Prop({ default: () => [] }) value!: any[];
  @Prop({ default: ".draggable-list-handle" }) handle!: string;

  input(...args: any[]) {
    this.$emit("input", ...args);
  }
}
